import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';

import Preloading from '../../../components/basics/Preloading';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import emptyMenu from "../../../assets/images/img/emptyMenu.svg";

const KitchenHome = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [branchId, setBranchId] = useState(0);
  const [userBaseInfo, setuserBaseInfo] = useState({
    userId: 0,
    profileId: 0,
    firstName: "",
    lastName: "",
    avatar: null,
    employeeId: 0,
    branchTitle: "",
    employeeCode: "",
    employeeType: 0,
    branchId: 0,
    restaurantId: 0
  });

  const baseInfoMap = (model) => {
    userBaseInfo.userId = model.userId;
    userBaseInfo.profileId = model.profileId;
    userBaseInfo.firstName = model.firstName;
    userBaseInfo.lastName = model.lastName;
    userBaseInfo.avatar = model.avatar;
    userBaseInfo.employeeId = model.employeeId;
    userBaseInfo.branchTitle = model.branchTitle;
    userBaseInfo.employeeCode = model.employeeCode;
    userBaseInfo.employeeType = model.employeeType;
    userBaseInfo.branchId = model.branchId;
    userBaseInfo.restaurantId = model.restaurantId;
    setBranchId(userBaseInfo.branchId);
    setuserBaseInfo({ ...userBaseInfo });
  }

  const getBaseInfo = async () => {
    const apiRes = await apiMethod.getLoginedStaffInfo(7);
    if (!methods.showApiErrors(apiRes))
      return false;
    baseInfoMap(apiRes.data);
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getBaseInfo();
      setLoading(false);
    }
    fetchData();
  }, []);

  const moduleBinder = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        <div className='row'>
          {branchId > 0 &&
            <div className='col-lg-3 col-md-4'>
              <div className='card mb-4' onClick={() => { navigate(`/kitchen/${branchId}/orders`) }}>
                <div className='card-body text-center'>
                  <div>سفارشات پخت</div>
                </div>
              </div>
            </div>
          }
        </div>
        {branchId === 0 && (
          <div className="text-center">
            <div>
              <img src={emptyMenu} alt='noItem' />
            </div>
            <p>شعبه فعالی برای شما موجود نیست، لطفا با مسئول فروش هماهنگی لازم انجام شود.</p>
          </div>
        )}
      </>
    )
  };

  return (
    <>
      {moduleBinder()}
    </>
  )

}

export default KitchenHome;